export const getCheckProviderURL = '/astellas/server/providers/check-provider';
export const updateOnboardingStatusURL =(id:string)=> `/astellas/server/providers/${id}`;

export const getDataPrivacyNoticeURL = '/astellasserver/dataPrivacyNotice';
export const getTermsAndConditionsURL = '/astellasserver/termsAndConditions';

export const getProfessionalInfoURL =(id:string)=> `/astellas/server/providers/detail/${id}`;
export const getPrimarySpecialtyRefURL = '/astellas/server/chain/specialtyRef';
export const getCommunicationRefURL = '/astellasserver/communicationRef';

export const getPracticeInfoURL =(id:string)=> `/astellas/server/practice/${id}`;
export const getPracticeTypeRefURL = '/astellas/server/chain/practiceTypeRef?sort=order';
export const getStateRefURL = '/astellas/server/chain/stateRef?sort=name';
export const postPracticeInfoURL =(id:string)=>`/astellas/server/practice/create/${id}`;
export const updatePracticeInfoURL =(id:string,practiceId:string)=>`/astellas/server/practice/${id}/${practiceId}`;

export const getVendorListURL = '/astellas/server/vendors/list';
export const getVendorDetailsByNameURL = (name:string) => `/astellas/server/vendors/detail?vendorName=${name}`